export const FETCH_ADMIN_PAID_JOBS_UNDER_REVIEW =
  "FETCH_ADMIN_PAID_JOBS_UNDER_REVIEW";
export const FETCH_ADMIN_FREE_JOBS_UNDER_REVIEW =
  "FETCH_ADMIN_FREE_JOBS_UNDER_REVIEW";
export const FETCH_ADMIN_EXPIRED_JOBS = "FETCH_ADMIN_CURRENT_JOBS";
export const FETCH_ADMIN_PAID_COMPANY_LOGOS_FOR_REVIEW =
  "FETCH_ADMIN_PAID_COMPANY_LOGOS_FOR_REVIEW";
export const FETCH_ADMIN_FREE_COMPANY_LOGOS_FOR_REVIEW =
  "FETCH_ADMIN_FREE_COMPANY_LOGOS_FOR_REVIEW";
export const FETCH_ADMIN_COMPANY_PROFILES_FOR_REVIEW =
  "FETCH_ADMIN_COMPANY_PROFILES_FOR_REVIEW";
export const FETCH_ADMIN_REQUESTED_DELETE_ACCOUNTS =
  "FETCH_ADMIN_REQUESTED_DELETE_ACCOUNTS";
export const FETCH_ADMIN_PROMOTIONAL_REQUESTS =
  "FETCH_ADMIN_PROMOTIONAL_REQUESTS";

export const ADMIN_INITIAL_STATE = {
  jobs: {
    underReview: [],
    expired: [],
    promotionalRequests: [],
  },
  promotionServices: {
    featuredLogos: [],
  },
  underReviewFreebies: {
    jobs: [],
    companyFeaturedLogos: [],
  },
  companyProfiles: {
    underReview: [],
  },
  accounts: {
    requestedDelete: [],
  },
};

export const CLF_PROMOTION_TYPE = {
  underReview: "underReview",
  current: "current",
  expired: "expired",
};

export const COMPANY_PROFILE_TYPE = {
  underReview: "underReview",
  current: "current",
  expired: "expired",
};
